import React, { Component } from "react";
import ReactDOM from "react-dom";

import "./Modal.css";

const modalRoot = document.getElementById("modal-root");

class Modal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
    this.handleMouseMove = this.handleMouseDown.bind(this);
  }

  handleMouseDown(event, clickOutSide) {
    clickOutSide(event);
  }

  componentDidMount() {
    modalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    modalRoot.removeChild(this.el);
  }

  render() {
    const { children, open } = this.props;
    const { clickOutSide } = this.props;
    if (open) {
      return ReactDOM.createPortal(
        <div
          className="modal"
          onMouseDown={event => this.handleMouseDown(event, clickOutSide)}
        >
          {children}
        </div>,
        this.el
      );
    } else return null;
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js